export default {
  LIMP: 'limp', // กระเพลก
  OUT_OF_SHAPE: 'out of shape', // ผิดรูป
  DETERIORATE: 'deteriorate' // เสื้อม
}
